module.exports = __webpack_public_path__ + "img/show.49514813.svg";